import { Stack } from '@mui/material'

import { useCanAddNewOrder, useIsSimulation, useOrdersLimit } from '@/hooks'

import { useTexts } from '../useTexts'

export function useCopyToOperationsButtonData() {
  const canAddNewOrder = useCanAddNewOrder()
  const isSimulation = useIsSimulation()
  const ordersLimit = useOrdersLimit()
  const texts = useTexts()

  const copyToOperationsDisabled = !canAddNewOrder
  const copyToOperationsTooltip = copyToOperationsDisabled ? (
    <Stack spacing={1} textAlign="center">
      <span>{texts.duplicateDisabledTooltipTitle(isSimulation)}</span>
      <span>{texts.duplicateDisabledTooltipSubtitle(isSimulation, ordersLimit)}</span>
    </Stack>
  ) : (
    texts.copyToOperations
  )

  return {
    isSimulation,
    copyToOperationsTooltip,
    copyToOperationsDisabled,
  }
}
